import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Hardcoded fallback PayPal donation URL from design.md. Used when the
 * `VITE_DONATION_URL` env var is not set and no `href` prop is provided.
 */
export const DEFAULT_DONATION_URL = 'https://www.paypal.com/donate/?business=4XF2UZTY49U3C&no_recurring=0&item_name=If+this+platform+has+helped+you%2C+consider+supporting+its+growth.+Your+contribution+keeps+it+alive+and+evolving.&currency_code=USD';
/**
 * Resolve the donation URL: prefer the build-time env var `VITE_DONATION_URL`
 * (injected by Vite at bundle time), falling back to the hardcoded default.
 */
function getDonationUrl() {
    try {
        const envUrl = typeof import.meta !== 'undefined' &&
            import.meta.env &&
            import.meta.env.VITE_DONATION_URL;
        if (envUrl)
            return envUrl;
    }
    catch {
        // import.meta.env may not exist in test/SSR environments — fall through.
    }
    return DEFAULT_DONATION_URL;
}
const linkStyle = {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '0.4em',
    padding: '0.5em 0.9em',
    borderRadius: '0.375rem',
    border: '1px solid #d0d7de',
    background: '#ffd140',
    color: '#1a1a1a',
    font: 'inherit',
    fontWeight: 600,
    textDecoration: 'none',
    cursor: 'pointer',
};
/**
 * Renders the PayPal donation link. Always opens in a new tab with safe `rel`.
 */
export function DonationButton({ href = getDonationUrl(), children = 'Support this platform', className, }) {
    return (_jsx("a", { href: href, target: "_blank", rel: "noopener noreferrer", className: className, style: linkStyle, children: children }));
}
//# sourceMappingURL=DonationButton.js.map